import React, { useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { RiArrowUpSLine, RiFilterFill, RiFilterOffFill } from 'react-icons/ri';
import { useApp } from '../../context/AppContext';
import { Container, Icon, IconButton, Label, Options } from './styles';

export default function ActionButton() {
  const [showMenu, setShowMenu] = useState(false)

  const {goToTop, clearAllSelections, toggleShowFilter} = useApp()

  function ShowFilter() {
    setShowMenu(false)
    toggleShowFilter()
  }

  function ClearFilter() {
    setShowMenu(false)
    clearAllSelections()
  }

  function GoToTop() {
    setShowMenu(false)
    goToTop()
  }

  return( 
    <Container>
      <IconButton onClick={() => setShowMenu(!showMenu)}>
        <Icon>
          {showMenu ? <FaMinus size={16} color={'yellow'}/> : <FaPlus size={16} color={'yellow'}/> }
        </Icon>
      </IconButton>
      <Options showMenu={showMenu}>
        <li>
          <Label>Top</Label>
          <div onClick={() => GoToTop()}>
            <IconButton>
              <Icon>
                <RiArrowUpSLine size={24} color={'yellow'}/>
              </Icon>
            </IconButton>
          </div>
        </li>
        <li>
          <Label>Filter</Label>
          <IconButton onClick={() => ShowFilter()}>
            <Icon>
              <RiFilterFill size={18} color={'yellow'}/>
            </Icon>
          </IconButton>
        </li>
        <li>
          <Label>Clear</Label>
          <IconButton onClick={() => ClearFilter()}>
            <Icon>
              <RiFilterOffFill size={18} color={'yellow'}/>
            </Icon>
          </IconButton>
        </li>
      </Options>
    </Container>
  )
}